module.exports = __webpack_public_path__ + "img/logo.ef44cf30.jpg";